import React from "react";
import { NavLink } from "react-router-dom";
import { Header, BackStrip } from "../../../common/layout";
import { GridLoader } from "react-spinners";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { config } from "../../../config/config";
import * as keyLearningAreaActions from "../../../store/portal";
import * as adminActions from "../../../store/admin";
import { bindActionCreators } from "redux";
import { css } from "@emotion/core";
import _ from "lodash";
import { deviceDetect } from "react-device-detect";
import { utilService, utilPostService } from "../../../common/utils";

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

/**
 * KLA Componet is used to display all the key learning areas
 */
class KeyLearningArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // google analytic page view
    utilService.pageView();

    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "key-learning-area",
      title: "Courses",
      browserName: browserName,
      osName: osName,
      pageType: "Courses Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    // fetch all key learning records
    this.props.fetchKeyLearningAreas({
      token: this.props.token,
      params: "",
    });
  }

  render() {
    const { keyLearningAreas } = this.props;
    return (
      <div>
        <BackStrip nav="/" isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header
              cname="admin-home"
              scriptTitle={true}
              text={"Course Directory"}
            />
            <main className="blurb pt-3">
              <Container fluid className="container-default-space pt-5">
                {this.props.pageActionLoading === true && (
                  <div className="sweet-loading">
                    <GridLoader
                      css={override}
                      sizeUnit={"px"}
                      size={40}
                      color={"#cadb2a"}
                      loading={this.props.pageActionLoading}
                    />
                  </div>
                )}
                <Row>
                  {keyLearningAreas &&
                    _.sortBy(keyLearningAreas, [
                      function (kla) {
                        return kla.key_learning_area;
                      },
                    ]).map((kla) => {
                      return (
                        <Col
                          key={kla.klaUid}
                          lg={2}
                          md={3}
                          xs={6}
                          className="text-center mb-4"
                        >
                          <NavLink
                            to={`/key-learning-area/${kla.klaUid}`}
                            className="d-inline-block"
                          >
                            <img
                              src={
                                kla.imageUrl ||
                                this.props.settings.banner_images.ribbon_logo
                              }
                              alt={kla.key_learning_area}
                              className="img-fluid mh-250 border-bottom pb-3"
                            />
                            <span className="d-block h3">
                              {kla.key_learning_area}
                            </span>
                          </NavLink>
                        </Col>
                      );
                    })}
                </Row>
              </Container>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 */
function mapStateToProps(state) {
  // console.log("State ==========", state);
  return {
    pageActionLoading: state.keyLearningArea.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    keyLearningAreas: Object.values(state.keyLearningArea.byId),
    settings: state.user.user
      ? state.settings.byId[state.user.user.schoolUid]
      : "",
  };
}
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(
    Object.assign({}, keyLearningAreaActions, adminActions),
    dispatch
  )
)(KeyLearningArea);
